export default "__VITE_ASSET__BoK7ZU5x__"